var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNewsAndJoinBg = function SvgNewsAndJoinBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 896,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2075.4 5.424s9.25 31.172 41.96 129.803c32.71 98.632 35.37 61.099 47.46 121.821 12.08 60.723 64.44 28.489 69.93 95.063 5.49 66.573 69.51 99.949-51.13 129.037-119.75 29.003-341.57 47.662-419.31 57.726-77.75 10.064 353.34 596.776 286.69 610.626-66.65 13.85-1507.185 257.18-1560.149 264.5-52.928 7.68-169.808 1.37-287.152 27.53-118.23 26.25-328.81-445.89-451.967-424.39-123.122 21.87-306.914-154.467-390.506-158.753-83.592-4.287-123.115-52.686-96.168-107.458 26.947-54.773-21.578-131.758-29.656-188.018-8.964-56.176-30.869-88.743 17.314-155.244s-90.25-83.05 103.135-109.048c193.385-25.998 505.604-90.604 664.317-95.757 158.712-5.153 132.588-35.08 470.683-72.344C828.947 93.254 895.35 39.544 1059.91 48.741c164.56 9.197 210.05-29.46 498.3-54.862s525.24-90.996 517.19 11.545Z",
    fill: "#F5D193"
  })));
};

export default SvgNewsAndJoinBg;